
import FormInput from './Input/Input';
import FormTextarea from './Textarea/Textarea';

export default function Content({id, sClass, formType, type, label, name, value, handleEdit}) {

    return (
        <>
            {
            type === 'form-input' ?
                <FormInput 
                    id={id}
                    sClass={sClass}
                    FormType={formType}
                    type={type}
                    label={label}
                    name={name}
                    value={value}
                    handleEdit={handleEdit}
                />
            :
            type === 'form-textarea' ?
                <FormTextarea 
                    id={id}
                    sClass={sClass}
                    FormType={formType}
                    type={type}
                    label={label}
                    name={name}
                    value={value}
                    handleEdit={handleEdit}
                />
            :
                <FormInput 
                    id={id}
                    sClass={sClass}
                    FormType={formType}
                    type={type}
                    label={label}
                    name={name}
                    value={value}
                    handleEdit={handleEdit}
                />
            }
        </>
    )
}
